import http from '../http'

const {assertAdminUploadFiles} = require('@/utils/uploadLimits.cjs')

export async function fetchCrmPartners() {
    return await http.post('/crm/partners/list')
}

export async function fetchCrmPartnerPage(payload = {}) {
    return await http.post('/crm/partners/page', payload)
}

export async function exportCrmReport(payload = {}) {
    const response = await http.post('/crm/report-exports/export', payload, {
        responseType: 'blob',
        timeout: 60000,
    })
    const contentType = response.headers && response.headers['content-type'] ? response.headers['content-type'] : ''
    if (contentType.includes('application/json') && response.data && typeof response.data.text === 'function') {
        const text = await response.data.text()
        const result = text ? JSON.parse(text) : {}
        throw new Error(result.message || '报表导出失败，请稍后重试')
    }
    return response
}

export async function fetchCrmLearningRecordPage(payload = {}) {
    return await http.post('/crm/learning-records/page', payload)
}

export async function exportCrmLearningRecords(payload = {}) {
    const response = await http.post('/crm/learning-records/export', payload, {
        responseType: 'blob',
        timeout: 60000,
    })
    const contentType = response.headers && response.headers['content-type'] ? response.headers['content-type'] : ''
    if (contentType.includes('application/json') && response.data && typeof response.data.text === 'function') {
        const text = await response.data.text()
        const result = text ? JSON.parse(text) : {}
        throw new Error(result.message || '学习留痕导出失败，请稍后重试')
    }
    return response
}

export async function createCrmPartner(payload) {
    return await http.post('/crm/partners', payload)
}

export async function updateCrmPartner(id, payload) {
    return await http.post('/crm/partners/update', {...payload, id})
}

/** 显式补齐历史合作生态的默认成员，并返回冲突清单。 */
export async function reconcileCrmPartnerDefaultPilots() {
    return await http.post('/crm/partners/default-pilots/reconcile')
}

export async function fetchCrmProducts() {
    return await http.post('/crm/products/list')
}

export async function fetchCrmProductPage(payload) {
    return await http.post('/crm/products/page', payload)
}

export async function createCrmProduct(payload) {
    return await http.post('/crm/products', payload)
}

export async function updateCrmProduct(id, payload) {
    return await http.post('/crm/products/update', {...payload, id})
}

export async function fetchCrmOperationStandardPage(payload = {}) {
    return await http.post('/crm/operation-standards/page', payload)
}

export async function createCrmOperationStandard(payload) {
    return await http.post('/crm/operation-standards', payload)
}

export async function batchCreateCrmOperationStandards(formData) {
    assertAdminUploadFiles(formData.getAll('files'))
    return await http.post('/crm/operation-standards/batch-create', formData, {
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: 60000,
    })
}

export async function updateCrmOperationStandard(id, payload) {
    return await http.post('/crm/operation-standards/update', {...payload, id})
}

export async function updateCrmOperationStandardStatus(payload) {
    return await http.post('/crm/operation-standards/update-status', payload)
}

export async function checkCrmOperationStandardPreview(id) {
    return await http.post('/crm/operation-standards/preview-check', {id})
}

export async function fetchCrmOperationStandardBundles() {
    return await http.post('/crm/operation-standards/bundles/list')
}

export async function saveCrmOperationStandardBundle(payload) {
    return await http.post('/crm/operation-standards/bundles/save', payload)
}

export async function updateCrmOperationStandardBundleStatus(payload) {
    return await http.post('/crm/operation-standards/bundles/update-status', payload)
}

export async function fetchCrmFlightTaskTypes() {
    return await http.post('/crm/operation-standards/task-types/list')
}

export async function saveCrmFlightTaskType(payload) {
    return await http.post('/crm/operation-standards/task-types/save', payload)
}

export async function updateCrmFlightTaskTypeStatus(payload) {
    return await http.post('/crm/operation-standards/task-types/update-status', payload)
}

export async function fetchCrmQuotations() {
    return await http.post('/crm/quotations/list')
}

export async function fetchCrmQuotationPage(payload = {}) {
    return await http.post('/crm/quotations/page', payload)
}

export async function createCrmQuotation(payload) {
    return await http.post('/crm/quotations', payload)
}

export async function updateCrmQuotation(id, payload) {
    return await http.post('/crm/quotations/update', {...payload, id})
}

export async function submitCrmQuotationApproval(id, payload) {
    return await http.post('/crm/quotations/submit-approval', {...payload, id})
}

/** 报价维护人撤销待审批报价，使其恢复为草稿。 */
export async function revokeCrmQuotationApproval(id, payload = {}) {
    return await http.post('/crm/quotations/revoke-approval', {...payload, id})
}

export async function approveCrmQuotation(id, payload) {
    return await http.post('/crm/quotations/approve', {...payload, id})
}

export async function rejectCrmQuotation(id, payload) {
    return await http.post('/crm/quotations/reject', {...payload, id})
}

export async function fetchCrmContracts() {
    return await http.post('/crm/contracts/list')
}

export async function fetchCrmContractPage(payload = {}) {
    return await http.post('/crm/contracts/page', payload)
}

export async function createCrmContract(payload) {
    return await http.post('/crm/contracts', payload)
}

export async function updateCrmContract(id, payload) {
    return await http.post('/crm/contracts/update', {...payload, id})
}

/** 销售在当前合同详情补传历史发票，合同 ID 由路径锁定，附件与票面资料一次性提交。 */
export async function recordCrmContractLegacyInvoiceIssue(contractId, payload, files = []) {
    const rawFiles = files.map((file) => file.raw || file)
    assertAdminUploadFiles(rawFiles)
    const form = new FormData()
    form.append('request', new Blob([JSON.stringify(payload)], {type: 'application/json'}))
    rawFiles.forEach((file) => form.append('files', file))
    return await http.post(`/crm/contracts/${encodeURIComponent(contractId)}/invoices/record-legacy-issue`, form)
}

/** 经办人在本人历史合同中上传到账凭证，按合同总额一次完成结清归档。 */
export async function recordCrmHistoricalContractSettlement(contractId, payload, files = []) {
    const rawFiles = files.map((file) => file.raw || file)
    assertAdminUploadFiles(rawFiles)
    const form = new FormData()
    form.append('request', new Blob([JSON.stringify(payload)], {type: 'application/json'}))
    rawFiles.forEach((file) => form.append('files', file))
    return await http.post(`/crm/contracts/${encodeURIComponent(contractId)}/record-historical-settlement`, form)
}

export async function submitCrmContractApproval(id, payload) {
    return await http.post('/crm/contracts/submit-approval', {...payload, id})
}

export async function approveCrmContract(id, payload) {
    return await http.post('/crm/contracts/approve', {...payload, id})
}

export async function rejectCrmContract(id, payload) {
    return await http.post('/crm/contracts/reject', {...payload, id})
}

export async function updateCrmContractStatus(id, payload) {
    return await http.post('/crm/contracts/update-status', {...payload, id})
}

export async function launchProjectFromContract(id) {
    return await http.post('/crm/contracts/launch-project', {id})
}

/** 查询历史合同激活履约前的四项资料就绪度。 */
export async function fetchCrmHistoricalContractReadiness(id) {
    return await http.post('/crm/contracts/historical-readiness', {id})
}

/** 激活满足前置条件的历史归档合同。 */
export async function activateCrmHistoricalContract(id) {
    return await http.post('/crm/contracts/activate-historical', {id})
}

/** 维护历史待激活合同的产品/服务快照。 */
export async function updateCrmHistoricalContractItems(payload) {
    return await http.post('/crm/contracts/historical-items', payload)
}

/** 下载历史合同批量导入模板（xlsx）。 */
export async function downloadCrmContractImportTemplate() {
    return await http.post('/crm/contracts/import-template', {}, {responseType: 'blob'})
}

/** 预览历史合同导入文件，逐行校验不落库。 */
export async function previewCrmContractImport(formData) {
    return await http.post('/crm/contracts/import/preview', formData)
}

/** 下载历史合同导入预览结果及待补齐清单。 */
export async function downloadCrmContractImportPreview(formData) {
    return await http.post('/crm/contracts/import/preview-export', formData, {responseType: 'blob'})
}

/** 提交历史合同导入，整批成功或整批失败。 */
export async function submitCrmContractImport(formData) {
    return await http.post('/crm/contracts/import/submit', formData, {timeout: 120000})
}

/** 查询历史合同导入后台任务的真实进度。 */
export async function fetchCrmContractImportStatus(batchNo) {
    return await http.get(`/crm/contracts/import/${encodeURIComponent(batchNo)}/status`)
}

/** 查询当前账号最近一个进行中的历史合同导入任务。 */
export async function fetchCrmLatestActiveContractImport() {
    return await http.get('/crm/contracts/import/latest-active')
}

export async function fetchCrmProjects() {
    return await http.post('/crm/projects/list')
}

export async function fetchCrmProjectPage(payload = {}) {
    return await http.post('/crm/projects/page', payload)
}

export async function fetchCrmProjectDetail(id) {
    return await http.post('/crm/projects/detail', {id})
}

export async function updateCrmProjectProfile(payload) {
    return await http.post('/crm/projects/profile/update', payload)
}

/**
 * 更新项目执行主档的基础字段，不处理合同关联和状态流转。
 */
export async function updateCrmProjectBasicInfo(payload) {
    return await http.post('/crm/projects/basic-info/update', payload)
}

/** 保存合同增补、售后、免费或应急项目草稿。 */
export async function saveCrmSupplementalProject(payload) {
    return await http.post('/crm/projects/supplemental/save', payload)
}

/** 提交补充项目立项审批；后端会再次校验真实可处理账号。 */
export async function submitCrmSupplementalProjectApproval(id, payload = {}) {
    return await http.post('/crm/projects/supplemental/submit-approval', {...payload, id})
}

export async function approveCrmSupplementalProject(id, payload = {}) {
    return await http.post('/crm/projects/supplemental/approve', {...payload, id})
}

export async function rejectCrmSupplementalProject(id, payload = {}) {
    return await http.post('/crm/projects/supplemental/reject', {...payload, id})
}

export async function deleteCrmProject(id) {
    return await http.post('/crm/projects/delete', {id})
}

export async function fetchCrmProjectPool() {
    return await http.post('/crm/project-pool/list')
}

export async function fetchCrmProjectPoolPage(payload = {}) {
    return await http.post('/crm/project-pool/page', payload)
}

export async function fetchCrmProjectPoolOptions() {
    return await http.post('/crm/project-pool/options')
}

export async function openCrmProjectPool(payload) {
    return await http.post('/crm/project-pool/open', payload)
}

export async function closeCrmProjectPool(id, payload = {}) {
    return await http.post('/crm/project-pool/close', {...payload, id})
}

export async function fetchCrmPartnerApplications() {
    return await http.post('/crm/partner-applications/list')
}

export async function fetchCrmPartnerApplicationPage(payload = {}) {
    return await http.post('/crm/partner-applications/page', payload)
}

export async function reviewCrmPartnerApplication(id, payload) {
    return await http.post('/crm/partner-applications/review', {...payload, id})
}

export async function revokeCrmPartnerApplicationReview(id, payload = {}) {
    return await http.post('/crm/partner-applications/revoke-review', {...payload, id})
}

export async function fetchCrmFlightTasks() {
    return await http.post('/crm/flight-tasks/list')
}

export async function fetchCrmFlightTaskPage(payload = {}) {
    return await http.post('/crm/flight-tasks/page', payload)
}

/**
 * 分页读取项目交付影像资料批次。
 */
export async function fetchCrmMediaAssetPage(payload = {}) {
    return await http.post('/crm/media-assets/page', payload)
}

/**
 * 读取单个影像资料批次及其客户可见资料包快照。
 */
export async function fetchCrmMediaAssetDetail(payload) {
    return await http.post('/crm/media-assets/detail', payload)
}

export async function fetchCrmFlightTaskCalendar(payload = {}) {
    return await http.post('/crm/flight-tasks/calendar/list', payload)
}

export async function fetchCrmFlightPilotAssessmentPage(payload = {}) {
    return await http.post('/crm/flight-tasks/pilot-assessments/page', payload)
}

/** 读取当前账号可见飞手评价对应的筛选选项。 */
export async function fetchCrmFlightPilotAssessmentOptions() {
    return await http.post('/crm/flight-tasks/pilot-assessments/options')
}

export async function fetchCrmFlightPilotAssessmentDetail(payload = {}) {
    return await http.post('/crm/flight-tasks/pilot-assessments/detail', payload)
}

export async function fetchCrmFlightPilots() {
    return await http.post('/crm/flight-tasks/pilots/list')
}

export async function fetchCrmLeadSurveyPilots() {
    return await http.post('/crm/leads/survey-pilots/list')
}

export async function fetchCrmFlightPilotProfiles() {
    return await http.post('/crm/flight-pilots/list')
}

export async function fetchCrmFlightPilotProfilePage(payload = {}) {
    return await http.post('/crm/flight-pilots/page', payload)
}

export async function createCrmFlightPilotProfile(payload) {
    return await http.post('/crm/flight-pilots', payload)
}

export async function updateCrmFlightPilotProfile(id, payload) {
    return await http.post('/crm/flight-pilots/update', {...payload, id})
}

export async function deleteCrmFlightPilotProfile(id) {
    return await http.post('/crm/flight-pilots/delete', {id})
}

export async function saveCrmFlightPilotProfile(payload) {
    return await http.post('/crm/flight-pilots/save', payload)
}

export async function reviewCrmFlightPilotCertification(payload) {
    return await http.post('/crm/flight-pilots/review-certification', payload)
}

/** 分页读取合作生态成员岗位申请。 */
export async function fetchCrmFlightPilotPositionApplicationPage(payload = {}) {
    return await http.post('/crm/flight-pilots/position-applications/page', payload)
}

/** 读取合作生态成员岗位申请详情。 */
export async function fetchCrmFlightPilotPositionApplicationDetail(payload) {
    return await http.post('/crm/flight-pilots/position-applications/detail', payload)
}

/** 审核合作生态成员岗位申请。 */
export async function reviewCrmFlightPilotPositionApplication(payload) {
    return await http.post('/crm/flight-pilots/position-applications/review', payload)
}

export async function assignCrmFlightTask(payload) {
    return await http.post('/crm/flight-tasks/assign', payload)
}

/** 保存平台自营任务；taskId 为空时创建，传入时调整飞手和排期。 */
export async function saveCrmSelfOperatedFlightTask(payload) {
    return await http.post('/crm/flight-tasks/self-operated/save', payload)
}

export async function applyCrmFlightTaskType(payload) {
    return await http.post('/crm/flight-tasks/task-type/apply', payload)
}

/** 删除尚未产生作业留痕的任务。 */
export async function deleteCrmFlightTask(id) {
    return await http.post('/crm/flight-tasks/delete', {id})
}

export async function voidCrmFlightTaskCode(payload) {
    return await http.post('/crm/flight-tasks/code/void', payload)
}

export async function regenerateCrmFlightTaskCode(payload) {
    return await http.post('/crm/flight-tasks/code/regenerate', payload)
}

export async function removeCrmFlightTaskMember(payload) {
    return await http.post('/crm/flight-tasks/members/remove', payload)
}

export async function deleteCrmFlightTaskWorkLog(payload) {
    return await http.post('/crm/flight-tasks/work-logs/delete', payload)
}

export async function reviewCrmFlightTaskResult(payload) {
    return await http.post('/crm/flight-tasks/review-result', payload)
}

export async function handleCrmFlightTaskException(payload) {
    return await http.post('/crm/flight-tasks/exceptions/handle', payload)
}

export async function fetchCrmTrainingLearningExceptions(taskId) {
    return await http.post('/crm/flight-tasks/training-exceptions/list', {taskId})
}

export async function reviewCrmTrainingLearningException(payload) {
    return await http.post('/crm/flight-tasks/training-exceptions/review', payload)
}

export async function fetchCrmAcceptances() {
    return await http.post('/crm/acceptance/list')
}

export async function fetchCrmAcceptancePage(payload = {}) {
    return await http.post('/crm/acceptance/page', payload)
}

export async function fetchCrmAcceptanceByProject(projectId) {
    return await http.post('/crm/acceptance/by-project', {projectId})
}

/** 查询当前账号可补录线下验收的项目及前置检查。 */
export async function fetchManualAcceptanceCandidates() {
    return await http.post('/crm/acceptance/manual-candidates')
}

/** 记录真实线下验收结果，项目仅推进至待归档。 */
export async function confirmManualAcceptance(payload) {
    return await http.post('/crm/acceptance/manual-confirm', payload)
}

/** 发送客户小程序站内验收提醒，业务状态保持不变。 */
export async function remindCrmAcceptance(id) {
    return await http.post('/crm/acceptance/remind', {id})
}

/** 撤回待客户初审验收，原因仅用于内部审计。 */
export async function withdrawCrmAcceptance(id, reason) {
    return await http.post('/crm/acceptance/withdraw', {id, reason})
}

export async function startCrmAcceptance(payload) {
    return await http.post('/crm/acceptance/start', payload)
}

export async function submitCrmAcceptanceFeedback(id, payload) {
    return await http.post('/crm/acceptance/feedback', {...payload, id})
}

export async function submitCrmAcceptanceRevision(id, payload) {
    return await http.post('/crm/acceptance/revision', {...payload, id})
}

export async function approveCrmAcceptance(id, payload) {
    return await http.post('/crm/acceptance/approve', {...payload, id})
}

export async function archiveCrmAcceptance(id, payload = {}) {
    return await http.post('/crm/acceptance/archive', {...payload, id})
}

export async function fetchOperationLogs() {
    return await http.post('/system/operation-logs/list')
}

export async function fetchOperationLogPage(payload = {}) {
    return await http.post('/system/operation-logs/page', payload)
}

// ==================== 附件管理 API ====================

/**
 * 上传附件
 * @param {FormData} formData - 包含 file、bizType、bizId 的 FormData
 */
export async function uploadAttachment(formData) {
    assertAdminUploadFiles([formData.get('file')], {checkBatch: false})
    return await http.post('/attachments/upload', formData, {
        headers: {'Content-Type': 'multipart/form-data'},
    })
}

/**
 * 删除附件
 * @param {number} id - 附件 ID
 */
export async function deleteAttachment(id) {
    return await http.post('/attachments/delete', {id})
}

/**
 * 查询业务对象的附件列表
 * @param {string} bizType - 业务类型（如 quotation）
 * @param {number} bizId - 业务对象 ID
 */
export async function listAttachments(bizType, bizId) {
    return await http.post('/attachments/list', {bizType, bizId})
}
